var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKakao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\xEA\xB2\xA9\xEB\xA6\xAC_\xEB\xAA\xA8\xEB\x93\x9C",
    clipPath: "url(#clip0_476_2497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5011 0C4.70048 0 0 3.65876 0 8.17459C0 11.1125 1.99169 13.69 4.98136 15.1296C4.76218 15.9364 4.18553 18.0549 4.07062 18.5076C3.92806 19.0692 4.27916 19.0629 4.50897 18.912C4.68984 18.7925 7.38585 16.9862 8.5498 16.2088C9.18178 16.301 9.83291 16.3492 10.4989 16.3492C16.2974 16.3492 21 12.6904 21 8.17459C21 3.65876 16.2995 0 10.5011 0Z",
    fill: "#371D1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_476_2497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakao);
export default __webpack_public_path__ + "static/media/kakao.2d95f6caf91152273556ad6ac9cbf32b.svg";
export { ForwardRef as ReactComponent };